import { axios } from '@Root/API'

export const edit = ({ id, name }) => {
	return axios.put(`update/fee-status/${id}`, { name })
}
